import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { SheetDatanew } from '../../../services/auth-service/authService'
import { Fetchexecutequery,Fetchheaderdata,Fetchupdatequery,Fetchconsolidateprocess  } from '../../../services/demo/bsr/brsService1';
import DynamicForm from '../po_process/DynamicForm';
import { AgGridReact } from 'ag-grid-react';
import Select, { components } from "react-select";
import { faTrash, faEdit, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon component
import {GetProcessNames, SaveRelationship,CreateData } from '../../../services/process/process_data/process_data';
import LoaderComponent from "../../../libraries/loader/loader";


const identifier = [
  { value: "string", label: "string" },
  { value: "int", label: "int" },
  { value: "special charectors", label: "special charectors" },
  { value: "contains", label: "contains" },
  { value: "starts with", label: "starts with" },
  { value: "ends with", label: "ends with" },

];

const identifier1 = [
  { value: "salary_report", label: "Salary Report" },{ value: "invoice_validation", label: "Invoice Validation Report" }
];

const options = [1,2,3,4,5,6,7,8,9,10]

const ValueContainer = ({ children, getValue, ...props }) => {
  let maxToShow = 1;
  var length = getValue().length;
  let displayChips = React.Children.toArray(children).slice(0, maxToShow);
  let shouldBadgeShow = length > maxToShow;
  let displayLength = length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && displayChips}
      <div className="root">
        {/* {shouldBadgeShow &&
          `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
      </div>
    </components.ValueContainer>
  );
};


const Headerconfig = () => {
  const [configName, setConfigName] = useState('');
  const [description, setDescription] = useState('');
  const [headerid, setHeaderid] = useState('');
  const [database, setDatabase] = useState('');
  const [relationshipType, setRelationshipType] = useState({});
  const [databaseNames, setDatabaseOptions] = useState([]);
  const [tableNames, setTableOptions] = useState([]);
  const [tableNames1, setTableOptions1] = useState([]);
  const [functionNames, setFunctionOptions] = useState([]);
  const [headerNames, setHeaderOptions] = useState([]);
  const [selectedprocess1, setSelectedprocess1] = useState([]);
  const [rows, setRows] = useState([{ id: 1, schema: null, table: null, header: null, function: null, customOptions: {}, headerOptions: [], tableOptions1: [] }]);
  // Create state variable for the Select component's value
  const [selectedSource, setSelectedSource] = useState('');
  const [selectedSchema, setSelectedSchema] = useState('');
  const [selectedTable, setSelectedTable] = useState('');
  const [selectedHeader, setSelectedHeader] = useState('');
  const [selectedFunction, setSelectedFunction] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fields, setFields] = useState(null);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [editRowId, setEditRowId] = useState(null); // State to track the row being edited
  const [editedDescription, setEditedDescription] = useState(''); // State for the new description value
  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [showExcelIcon, setShowExcelIcon] = useState(false);


const handleFileChange = (event) => {
  setFile(event.target.files[0]);  // Assuming only one file is selected
};

const handleFileChange1 = (event) => {
  setFile1(event.target.files[0]);  // Assuming only one file is selected
};


const handleEditClick = (row) => {
  setEditRowId(row.id); // Set the row ID being edited
  setEditedDescription(row.description || ''); // Initialize the current description value
};

  const handleSaveClick = (row) => {
    console.log("row data",row,row.id,editedDescription)
    const updatedRows = rowData.map((item) =>
      item.id === row.id ? { ...item, description: editedDescription } : item
    );
    setRowData(updatedRows);
    setEditRowId(null); // Exit edit mode


    const payload = {
      schema_name: 'bsr',
      table: 'file_uploads',
      set_column : [{'description' : editedDescription }],
      'where' : [{"id" : row.id}]
    };


    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };


  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
};

  // Handle the change event for the Select component
  const handleSelectChange = (event, { value }) => {
    setDatabase(event);
  };


const handleUpdate1 = async () => {
      setShowExcelIcon(false);
setLoaderOpen(true);
  const formData = new FormData();
  formData.append('file', file);
  formData.append('file1', file1);

  try {
    const response = await fetch('http://172.16.40.14:5101/api/v2/bsr/upload/', {
      method: 'POST',
      body: formData,
    });

    if (response.ok) {
      const responseData = await response.json();
      //console.log('File uploaded successfully', responseData.file_path);
      setFile2(responseData.file_path);
      setFile(null);
      setFile1(null);
      setShowExcelIcon(true);
      setLoaderOpen(false);
    } else {
      console.error('File upload failed');
      setLoaderOpen(false);
    }
  } catch (error) {
    console.error('Error:', error);
    setLoaderOpen(false);
  }
};



  const handleUpdate = () => {
    setLoaderOpen(true);
      if (!database) {
        alert("Please select a report type.");
        setLoaderOpen(false);
        return;
      }

    const sanitizedRows = rows.map(({ headerOptions, tableOptions1, ...rest }) => rest);
    const payload = {
     "report type" : database  };

    const FileUploadCredentials = Fetchconsolidateprocess();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setLoaderOpen(false);
	alert("Data updated successfully!");
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
        setLoaderOpen(false);
  // Safely access error message
  const errorMessage = error.response && error.response.data && error.response.data.message 
    ? error.response.data.message 
    : "An unexpected error occurred.";
  
  alert("Error consolidating data: " + errorMessage);
      });
  };


const handleDescriptionChange = (e) => {
  setEditedDescription(e.target.value); // Update the description state
};

  const handleDeleteClick = (row) => {
    console.log("selected row",row);

    const payload = {
      schema_name: 'bsr',
      table: 'file_uploads',
      set_column : [{'is_active' : 0 }],
      'where' : [{"id" : row.id}]
    };


    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
	fetchTableInfo1();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  }



  const gridColumnDefs = [
    { field: 'id', headerName: 'Sl no', sortable: true, filter: true, resizable: true, width: 130 },
    { field: 'report_type', headerName: 'Report Type', sortable: true, filter: true, resizable: true, width: 200 },
    { field: 'file_name', headerName: 'File name', sortable: true, filter: true, resizable: true, width: 200 },
    { field: 'created_on', headerName: 'Created on', sortable: true, filter: true, resizable: true, width: 200 }, 
    { 
    field: 'description', 
    headerName: 'Description', 
    sortable: true, 
    filter: true, 
    resizable: true, 
    width: 300,
    cellRendererFramework: (params) => {
      if (editRowId === params.data.id) {
        return (
          <input
  type="text"
  value={editedDescription}
  onChange={handleDescriptionChange}
  onBlur={() => handleSaveClick(params.data)} // Save on blur
  autoFocus
  style={{ width: '100%', padding: '5px' }}
/>
        );
      }
      return <span>{params.data.description}</span>;
    },
  },    
    {
    headerName: "Actions",
    field: "actions",
    cellRendererFramework: (params) => {
      return (
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center',padding:'10px' }}>
        <button 
          onClick={() => handleDownloadReport(params)}
          style={{ 
            background: 'transparent', 
            border: 'none', 
            cursor: 'pointer',
              padding:'2px'

          }}
        >
          <FontAwesomeIcon icon={faFileExcel} size="lg" color="green" />
        </button>
            <button 
              onClick={() => handleEditClick(params.data)}
              style={{ 
                background: 'transparent', 
                border: 'none', 
                cursor: 'pointer',
                padding: '2px',
              }}
            >
              <FontAwesomeIcon icon={faEdit} size="lg" color="blue" />
            </button>
          <button 
            onClick={() => handleDeleteClick(params.data)}
            style={{ 
              background: 'transparent', 
              border: 'none', 
              cursor: 'pointer'
            }}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" color="red" />
          </button>
        </div>
      );
    },
    width: 150, // Adjust width to fit both icons
  },   ]

   const handleDownloadReport = (params) => {
    // Assuming `params.data` contains the row data
    const rowData = params.data;
    console.log("rowdata",rowData)

    // Define your report file path (this could come from your backend or be dynamically generated)
    const filePath = `http://172.16.40.14:5101/static/output/${rowData.file_name}`; 
    // const filePath = `D:/advent/bsr/UserManagementModule/static/${rowData.file_name}`
    // Triggering the download
    downloadFile(filePath);
  };

   const handleDownloadReport1 = () => {
    // Assuming `params.data` contains the row data
    // Define your report file path (this could come from your backend or be dynamically generated)
    const filePath = `http://172.16.40.14:5101/static/output/${file2}`; 
    // const filePath = `D:/advent/bsr/UserManagementModule/static/${rowData.file_name}`
    // Triggering the download
    downloadFile(filePath);
  };


  const downloadFile = (filePath) => {
    // Triggering the download, this will work if your backend serves the file properly
    console.log("filepath",filePath)
    const link = document.createElement('a');
    link.href = filePath;
    link.click();
  };
const fetchTableInfo1 = async () => {
    const payload = {query: 'select * from bsr.file_uploads where is_active = 1 order by id desc;'};

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---', FileUploadCredentials[0])
  
    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          console.log(data)
          setRowData(data);

        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }

useEffect(() => {
  
  fetchTableInfo1();
},[]);
  return (
    <>
      <Grid  divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row style={{height:'90px'}}>
          <Grid.Column style={{width:'15%'}}>
            <div >
              <label className="label1 mb-1" htmlFor={`configNameInput`}>Report Type</label> <br />
              <div>
                <Select
                  clearable
                  options={identifier1}
                  selection
                  className="resource_input"
                  size='mini'
                  value={database}
                  onChange={handleSelectChange}
                />
              </div>
                  </div>
            </Grid.Column>
{database && database.value === 'salary_report' && (
  <>
    <Grid.Column style={{ paddingTop: '15px' }}>
      <button
        style={{
          height: "35px",
          width: "92px",
          backgroundColor: "#000055",
          color: "#ffffff",
          marginLeft: '2em',
        }}
        onClick={handleUpdate}
      >
        Run
      </button>
    </Grid.Column>
  </>
)}

{database && database.value === 'invoice_validation' && (
  <>    
    <Grid.Column style={{ width: '15%' }}>
      <div>
        <label className="label1 mb-1" htmlFor="fileUpload">Invoice Report</label> <br />
        <div>
          <input
            type="file"
            id="fileUpload"
            name="fileUpload"
            onChange={handleFileChange}
            className="resource_input"
          />
        </div>
      </div>
    </Grid.Column>
    <Grid.Column style={{ width: '15%' }}>
      <div>
        <label className="label1 mb-1" htmlFor="fileUpload">Salary Report</label> <br />
        <div>
          <input
            type="file"
            id="fileUpload"
            name="fileUpload"
            onChange={handleFileChange1}
            className="resource_input"
          />
        </div>
      </div>
    </Grid.Column>
    
    <Grid.Column style={{ paddingTop: '15px', width: '8%' }}>
      <button
        style={{
          height: "35px",
          width: "92px",
          backgroundColor: "#000055",
          color: "#ffffff",
          marginLeft: '.2em',
        }}
        onClick={handleUpdate1}
      >
        Run
      </button>
    </Grid.Column>

    <Grid.Column style={{ paddingTop: '15px' }}>
     {showExcelIcon && ( // Use this condition to toggle visibility of the Excel icon
      <FontAwesomeIcon 
        icon={faFileExcel} 
        size="lg" 
        color="green" 
        style={{ cursor: 'pointer',height:"35px" }} // Add pointer cursor for clarity
        onClick={() => handleDownloadReport1()} // Attach click handler
      />
    )}
    </Grid.Column>
  </>
)}



        </Grid.Row>
        </Grid>

      <Grid columns='equal' divided style={{ paddingLeft: "10px", borderRadius: "15px", margin: '0em',paddingTop:'30px' }} className="mt-2 mb-2">
 
        <div
          className="ag-theme-alpine"
          style={{
            overflowX: 'auto',
            overflowY: 'auto',
            borderRadius: '10px',
            width: `${ 6* 200}px`,
            maxWidth: '100%',
            maxHeight: '800px',
            height: '500px',
            paddingTop:'10px'
            
          }}
        >
          <AgGridReact
            columnDefs={gridColumnDefs}
            rowData={rowData}
            pagination={true}
            paginationPageSize={10}
          />
        </div>
      </Grid>
      <LoaderComponent loaderOpen={loaderOpen} />
    </>
  )
}

export default Headerconfig;